import React from 'react';
import { Box } from '@chakra-ui/react';
import { AICustomerGeneration } from 'components/coselling/AICustomerGeneration';

export const AICustomerGenerationPage = () => {
  return (
    <Box w="100%" minH="100vh" mt="100px" px={{ base: 2, md: 8 }} py={4}>
      <AICustomerGeneration />
    </Box>
  );
};
